import React from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Typography, Box } from '@mui/material';
import Transition from './common/Transition';
import { getAllContrats, addContrat } from '../../../services/ContratService';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';



const AddContractDialog = ({
  open,
  onClose,
  newContratName,
  setNewContratName,
  setContratOptions,
  snackbarShowMessage,
  addContratOrigin,
  handleChange,
  setNewContratType,
  setNewPeriode,
  setNewDateFin,
  getDateFinFromPeriod,
}) => {
  const handleAddContract = async () => {
    try {
      await addContrat(newContratName);
      const { data } = await getAllContrats();
      setContratOptions(data);

      const added = data.find(c =>
        c.nom_contrat?.trim().toLowerCase() === newContratName.trim().toLowerCase()
      );

      if (added) {
        if (addContratOrigin === 'mainForm') {
          handleChange('contratId', added.id);
          if (added.nom_contrat.toLowerCase() === 'cdi') {
            handleChange('periodeContrat', '3mois');
          } else {
            handleChange('periodeContrat', '');
          }
        } else if (addContratOrigin === 'changeContratDialog') {
          setNewContratType(added.id);
          if (added.nom_contrat.toLowerCase() === 'cdi') {
            setNewPeriode('3mois');
            setNewDateFin(getDateFinFromPeriod(new Date(), '3mois'));
          } else if (added.nom_contrat.toLowerCase() === 'stage') {
            setNewPeriode('6mois');
            setNewDateFin(getDateFinFromPeriod(new Date(), '6mois'));
          } else {
            setNewPeriode('');
            setNewDateFin(null);
          }
        }
      }

      snackbarShowMessage(<span><CheckCircleIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />Contrat ajouté </span>, 'success');
      setNewContratName('');
      onClose();
    } catch {
      snackbarShowMessage(<span style={{ display: 'flex', alignItems: 'center' }}>
        <ErrorOutlineIcon style={{ color: '#d32f2f', marginRight: 6 }} />Erreur ajout contrat </span>, 'error');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionComponent={Transition}
      keepMounted
      disableEnforceFocus
      disableAutoFocus
      sx={{ zIndex: 1301 }}
      slotProps={{ paper: {
        sx: {
          minHeight: '300px',
          borderRadius: 4,
          backgroundColor: '#f9fafb',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        },
      } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: `'Orbitron', 'Rajdhani', 'Segoe UI', sans-serif`,
          fontSize: '1.5rem',
          fontWeight: 700,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: '#1e293b',
          textShadow: '0 1px 2px rgba(0,0,0,0.1)',
          px: 3,
          pt: 3,
          pb: 1,
        }}
      >
        <AddIcon sx={{ verticalAlign: 'middle', mr: 0.75 }} />Ajouter un contrat
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 1, pb: 4, mt: 6 }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: '#0f172a',
            fontWeight: 600,
            fontSize: '1rem',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
            mb: 1,
          }}
        >
          Nom du contrat
        </Typography>
        <TextField
          placeholder="Ex: CDI, CDD, Stage..."
          fullWidth
          variant="outlined"
          value={newContratName}
          onChange={(e) => setNewContratName(e.target.value)}
          autoComplete="off"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#f8fafc',
              borderRadius: '10px',
              paddingX: '10px',
              transition: '0.3s ease',
              fontFamily: `'Segoe UI', Roboto, sans-serif`,
              boxShadow: 'inset 0 0 0px 1px #e2e8f0',
              '&:hover': {
                boxShadow: 'inset 0 0 0px 2px #cbd5e1',
              },
              '&.Mui-focused': {
                boxShadow: '0 0 0 3px #60a5fa88',
                borderColor: '#3b82f6',
                backgroundColor: '#fff',
              },
            },
            '& input::placeholder': {
              opacity: 0.5,
              fontStyle: 'italic',
              color: '#64748b',
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: 2,
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={handleAddContract}
          variant="contained"
          color="primary"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          Ajouter
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddContractDialog;